import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { z } from "zod";
import type { AccountingData} from "../accounting-data";
import { accountingDataZodSchema } from "../accounting-data";

type SetAccountingDataCommand = {
    readonly _id: string;
    readonly _type: "SET_ACCOUNTING_DATA_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly accountingData: AccountingData;
};

const setAccountingDataCommandFactory = (
    params: AccountingData
): SetAccountingDataCommand => {
    const command: SetAccountingDataCommand = {
        _id: "set-accounting-data-command-id",
        _type: "SET_ACCOUNTING_DATA_COMMAND",
        _createdAt: nowIsoAndUnix(),
        accountingData: params,
    };
    return command;
};

const setAccountingDataCommandZodSchema: z.ZodSchema<SetAccountingDataCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("SET_ACCOUNTING_DATA_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        accountingData: accountingDataZodSchema,
    });

export type { SetAccountingDataCommand };
export { setAccountingDataCommandFactory, setAccountingDataCommandZodSchema };
